"use client";

import { FavouriteIcon as FavoriteIconFull } from "@hugeicons-pro/core-solid-rounded";
import { FavouriteIcon } from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

type Props = ControlProps & {
  likes: number; // Absolute number, not "1k" or a formatted string.
  isAlreadyLiked?: boolean;
};

// likes/isAlreadyLiked are destructured out: the container spreads the rest onto the DOM node.
export function GameControlsLikes({ likes, isAlreadyLiked, ...props }: Props) {
  return (
    <ControlContainer {...props}>
      <ControlIcon icon={isAlreadyLiked ? FavoriteIconFull : FavouriteIcon} />
      <span className="text-foreground text-xs">{likes || 0}</span>
    </ControlContainer>
  );
}
